/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PricingModel } from "./PricingModel";
import type { ProductOption } from "./ProductOption";
import type { VisitType } from "./VisitType";

export interface OneTimeProductOption {
  name?: string | null;
  code: ProductOption;
  pricing?: PricingModel[];
  visit_types?: VisitType[];
  type?: "one-time";
}
